import { css, cx } from '@linaria/core'
import type React from 'react'
import type { ComponentProps, FC } from 'react'
import { NavLink } from 'react-router-dom'

import { fragments, style } from '#styles/index'
import { HeaderTabEntry } from './HeaderTabs'

const noTextDecorationClass = css`
  text-decoration: none !important;
`

const tabLinkClass = css`
  padding: 0 10px 2.5px 10px;
  height: 100%;
  display: flex;
  align-items: flex-end;
  color: ${style.themeColors.textDefault};
  border-bottom: 2px solid ${style.themeColors.lineDefault};
  transition: ease 0.25s border-color;

  ${fragments.textStyle.tab.m};

  &.active {
    border-bottom: 2px solid ${style.themeColors.lineImportant};
    color: ${style.themeColors.textImportant};
  }
`

export const NavLinkTabHeader: FC<
  Omit<ComponentProps<typeof NavLink>, 'children'> & {
    children: React.ReactNode
    className?: string
    active?: boolean
  }
> = ({ children, className, active, ...props }) => {
  return (
    <NavLink {...props} className={cx(tabLinkClass, noTextDecorationClass, className, active && 'active')}>
      <HeaderTabEntry>{children}</HeaderTabEntry>
    </NavLink>
  )
}
